import { Component, OnInit } from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ComparePassword, CompareQuestions } from 'src/app/core/constants/confirmed.validator';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { Select } from 'src/app/shared/models/select';

@Component({
  selector: 'app-modal-bienvenida',
  templateUrl: './modal-bienvenida.component.html',
  styleUrls: ['./modal-bienvenida.component.css']
})

export class ModalBienvenidaComponent implements OnInit {

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  usuarioForm: FormGroup;
  questions: Select[] = [];
  optionOne: string;
  optionTwo: string;

  constructor(
    public dialogPrimerIngresoRef: MatDialogRef<ModalBienvenidaComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private router: Router,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.getQuestions();
    this.usuarioForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(Constanst.REGEXP_PASSWORD)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern(Constanst.REGEXP_PASSWORD)]],
        questionOne: ['', [Validators.required]],
        answerOne: ['', [Validators.required, Validators.minLength(4)]],
        questionTwo: ['', [Validators.required]],
        answerTwo: ['', [Validators.required, Validators.minLength(4)]],
      },
      {
        asyncValidators: [ComparePassword('password', 'confirmPassword'), CompareQuestions('questionOne', 'questionTwo')],
        //asyncValidators1: CompareQuestions('questionTwo', 'questionOne'),
      });

  }

  getQuestions() {
    this.route = '/getSecurityQuestionActive';
    this.method = 'POST';

    this.apiCallService.call$(null, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          response.map((i: any) => {
            let opt: Select = { id: '', value: '' };
            opt.id = i.idSecurityQuestion;
            opt.value = i.description;
            this.questions.push(opt);
          });
        });
    this.apiCallService.hideSpinner();
  }

  onSubmit(valuesForm: any): void {
    if (this.usuarioForm.invalid) {
      return;
    } else {
      return this.confirm(valuesForm);
    }
  }

  confirm(valuesForm: any) {
    const dialogConfirm = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_UPDATE, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialogConfirm.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/saveFirstAdmission';
        this.method = 'POST';
        let idUser = this.localStorageService.getItem(Constanst.STORAGE_DATA_USER);
        let data = {
          userEntity: {
            idUser: idUser,
            password: valuesForm.password
          },
          firstSecurityQuestion: {
            securityQuestionEntity: {
              idSecurityQuestion: valuesForm.questionOne
            },
            userResponse: valuesForm.answerOne
          },
          secondSecurityQuestion: {
            securityQuestionEntity: {
              idSecurityQuestion: valuesForm.questionTwo
            },
            userResponse: valuesForm.answerTwo
          }
        }
        //console.log(data);
        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              //console.log(response);
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.localStorageService.setItem(Constanst.REMOTE_USE_CODE, response.data);
                this.localStorageService.setItem(Constanst.STORAGE_DATA_FIRSTADMISSION, 'false');
                this.apiCallService.hideSpinner();
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
                this.dialogPrimerIngresoRef.close();
              } else {
                this.apiCallService.hideSpinner();
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
            },
            error => {
              //console.log('Falla al guardar al usuario ', error)
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              //this.logoutAndCloseDialog();
            });
      } else {
        dialogConfirm.close(false);
      }

    });
  }

  logoutAndCloseDialog() {
    this.route = '/logout';
    this.method = 'POST';

    let data = {
      idUser: this.localStorageService.getItem(Constanst.STORAGE_DATA_USER)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          //if (response.status === 'SUCCESS') {
          this.helperClassService.localStorageClear();
          this.dialogPrimerIngresoRef.close();
            this.router.navigate(['/login']);
            this.apiCallService.hideSpinner();
          //}
        }
      );

  }

}
